import React, { useState } from 'react';
import { hasAnyRole } from '../../utils/roles';
import HomeroomRegister from './HomeroomRegister';
import SubjectPeriodRegister from './SubjectPeriodRegister';
import AttendanceRegisterView from './AttendanceRegisterView';
import AttendanceAnalytics from './AttendanceAnalytics';

const STAFF_ROLES = ['administrator', 'principal', 'head_of_academics', 'teacher'];

function Attendance({ token, user }) {
  const isStaff = hasAnyRole(user, STAFF_ROLES);
  const [tab, setTab] = useState('take');

  if (!isStaff) {
    return <AttendanceRegisterView token={token} user={user} />;
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <button
          className={tab === 'take' ? 'tab-active' : 'tab'}
          onClick={() => setTab('take')}
          style={{
            padding: '0.5rem 1rem', borderRadius: 'var(--radius)', border: '1px solid var(--color-border)',
            background: tab === 'take' ? 'var(--color-primary)' : 'var(--color-surface)',
            color: tab === 'take' ? 'white' : 'var(--color-text)', cursor: 'pointer', fontWeight: 600,
          }}
        >
          Take Attendance
        </button>
        <button
          onClick={() => setTab('view')}
          style={{
            padding: '0.5rem 1rem', borderRadius: 'var(--radius)', border: '1px solid var(--color-border)',
            background: tab === 'view' ? 'var(--color-primary)' : 'var(--color-surface)',
            color: tab === 'view' ? 'white' : 'var(--color-text)', cursor: 'pointer', fontWeight: 600,
          }}
        >
          View Registers
        </button>
        <button
          onClick={() => setTab('analytics')}
          style={{
            padding: '0.5rem 1rem', borderRadius: 'var(--radius)', border: '1px solid var(--color-border)',
            background: tab === 'analytics' ? 'var(--color-primary)' : 'var(--color-surface)',
            color: tab === 'analytics' ? 'white' : 'var(--color-text)', cursor: 'pointer', fontWeight: 600,
          }}
        >
          Analytics
        </button>
      </div>

      {tab === 'view' ? (
        <AttendanceRegisterView token={token} user={user} />
      ) : tab === 'analytics' ? (
        <AttendanceAnalytics token={token} />
      ) : user?.attendance_mode === 'subject_period' ? (
        <SubjectPeriodRegister token={token} user={user} />
      ) : (
        <HomeroomRegister token={token} user={user} />
      )}
    </div>
  );
}

export default Attendance;
